import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WysiwygEditorModule } from '../../../shared/wysiwyg-editor/wysiwyg-editor.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AddEditPostsComponent } from './add-edit-posts.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [AddEditPostsComponent],
  imports: [
    CommonModule,
    WysiwygEditorModule,
    LoadingModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ListGridModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    RouterModule,
    MatExpansionModule,
  ],
})
export class AddEditPostsModule {}
